<template>
    <hox-alert type="info" class="importExportModal__upload-result">
        <template #content>
            <p>Please select a primary key. This will be used as the variant name within the group.</p>
            <div>
                <RadioGroup
                    class="editable-group__values"
                    :vertical="true"
                    :model-value="modelValue"
                    @onChange="onChange"
                >
                    <Radio v-for="candidate in candidates" :key="candidate" :label="candidate">
                        {{ candidate }}
                    </Radio>
                </RadioGroup>
            </div>
        </template>
        <template #actionItems>
            <Button type="primary" @click="select">Save</Button>
        </template>
    </hox-alert>
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue";

export default defineComponent({
    name: "FeedPrimaryKeySelector",
    props: {
        modelValue: {
            type: String,
            required: true
        },
        candidates: {
            type: Array as PropType<string[]>,
            default() {
                return [];
            }
        }
    },

    emits: ["update:modelValue", "select"],

    methods: {
        onChange(value: string) {
            this.$emit("update:modelValue", value);
        },

        select() {
            this.$emit("select");
        }
    }
});
</script>
